:host {
  font-family: var(--font-family);
  font-size: var(--font-size);
  color: var(--color-fg-default);
  --max-width: 1080px;
}

.viewport-margins {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 1em;
}

a {
  color: var(--color-fg-default);
}

*:focus {
  box-shadow: 0 0 0 2px var(--color-bg-accent),0 0 0 4px var(--color-bg-accent-emphasis);
  outline: none;
}

.website-header__logo-name-container {
  display: flex;
  align-items: stretch;
  margin-right: auto;

  @media (max-width: 920px) {
    margin-right: 6em;
  }
}

.website-header_logo-link {
  line-height: 0;

  @media (max-width: 920px) {
    display: none;
  }
}

.website-header__logo {
  max-width: 260px;
  margin-right: 1em;
}

.website-header__service-link {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-decoration: none;
  line-height: 1;
  color: var(--color-penn-blue);

  @media (min-width: 921px) {
    border-left: solid 1px var(--color-penn-blue);
    padding-left: 0.75em;
  }
}

.website-header__service-link:hover .website-header__service-name {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: .1em;
  text-decoration-color: var(--color-fg-accent);
}

.website-header__service-name {
  font-size: 1.5em;
  font-weight: 500;

  @media (min-width: 921px) {
    font-size: 1.6em;
  }
}

.website-header__service-lede  {
  font-size: 1em;
}

.website-header__inner-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-top: 1em;
  padding-bottom: 1em;

  @media (max-width: 920px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 920px) {
  .website-header__navigation {
    width: 100%;
  }
}

.website-header__navigation-list {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;

  @media (max-width: 920px) {
    display: none;
  }
}

.website-header__navigation-list--visible {
  @media (max-width: 920px) {
    display: block;
    margin-top: 1rem;
    padding-bottom: 1rem;

    border-bottom: solid 1px var(--color-fg-subtle);
  }
}

.website-header__navigation-list--visible a {
  @media (max-width: 920px) {
    display: inline-block;
  }
}

.website-header__navigation-list button {
  background-color: transparent;
  border-width: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding: 0;
  color: inherit;
}

.website-header__navigation-list a,
.website-header__navigation-list button {
  display: block;
  text-decoration: none;
  cursor: pointer;

  @media (max-width: 920px) {
    padding: 0.75em 0;
  }
  @media (min-width: 921px) {
    padding: 0.5em;
  }
}

.website-header__navigation-list a:hover,
.website-header__navigation-list button:hover {
  text-decoration: underline;
  text-underline-offset: var(--link-text-underline-offset);
}

.website-header__navigation-button {
  all: unset;
  text-transform: uppercase;
  font-size: 0.75em;
  letter-spacing: 0.075em;
  font-weight: 600;
  padding: 0.5em 1em;
  border-radius: 0.25em;
  position: absolute;
  right: 1em;
  top: 1.5em;
  display: flex;
  align-items: center;
  padding-left: 0.5em;

  @media (min-width: 921px) {
    display: none;
  }
}

.website-header__navigation-button[aria-expanded=true] svg {
  rotate: 180deg;
}

.website-header__navigation-button:hover {
  cursor: pointer;
}